import React, { useState, useEffect } from 'react';
import { Modal, Spin, message } from 'antd';
import Overview from './Overview';
import { LedgerModel } from '@app/interfaces/ledger';
import { getLedgerApi } from '@app/api/ledger.api';

interface ModalProps {
  open: boolean;
  onCancel: () => void;
  title: string;
  recordId?: number;
}

const LedgerDetailModal: React.FC<ModalProps> = ({ recordId, open, onCancel, title }) => {
  const [record, setRecord] = useState<LedgerModel | null>(null);

  useEffect(() => {
    const fetchLedger = async () => {
      try {
        const response = await getLedgerApi(recordId as number);
        if (response) {
          setRecord(response);
        }
      } catch (error: any) {
        message.error(error.message || "Failed to fetch ledger details.");
      }
    }

    fetchLedger()
  }, [recordId]);

  return (
    <>
      <Modal
        open={open}
        width={1000}
        style={{ top: 20 }}
        onCancel={onCancel}
        footer={null}
      >
        <h3 className="mb-2 font-bold-weight">{title}</h3>
        {record ? (
          <Overview record={record} />
        ) : (
          <span className="flex-center p-4">
            <Spin />
          </span>
        )}
      </Modal>
    </>
  )
};

export default LedgerDetailModal;
